/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_payload_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decoded payload`)
};

const es_jw_payload_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga útil decodificada`)
};

const de_jw_payload_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dekodierte Payload`)
};

const nl_jw_payload_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gedecodeerde payload`)
};

const fr_jw_payload_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge utile décodée`)
};

const it_jw_payload_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payload decodificato`)
};

const pt_br2_jw_payload_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payload decodificado`)
};

const pt_jw_payload_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga descodificada`)
};

const ja_jw_payload_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デコード済みペイロード`)
};

const zh_jw_payload_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解码后的载荷`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_payload_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_payload_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_payload_label", locale)
	if (locale === "en") return en_jw_payload_label(inputs)
	if (locale === "es") return es_jw_payload_label(inputs)
	if (locale === "de") return de_jw_payload_label(inputs)
	if (locale === "nl") return nl_jw_payload_label(inputs)
	if (locale === "fr") return fr_jw_payload_label(inputs)
	if (locale === "it") return it_jw_payload_label(inputs)
	if (locale === "pt-BR") return pt_br2_jw_payload_label(inputs)
	if (locale === "pt") return pt_jw_payload_label(inputs)
	if (locale === "ja") return ja_jw_payload_label(inputs)
	return zh_jw_payload_label(inputs)
};